import React, { useEffect, useState } from 'react';
import styles from './leaseDetails.module.scss';
import CustomSelect from '../../../designSystem/CustomSelect/CustomSelect';
import DateInput from '../../../designSystem/DateInput/DateInput';
import LeaseDetailsProps from './LeaseDetails.props';
import { Price } from '@greystar/lib/src/types/property-types';
import { useFeesAnalytics, useAnalytics, getMaxDate, getLeaseTerm } from '@greystar/lib';

const LeaseDetailsSection = (props: LeaseDetailsProps) => {
  const [leaseTerms, setLeaseTerms] = useState<Price[]>([]);
  const maxDate = getMaxDate(props.selectedUnit);

  const leaseTerm = getLeaseTerm(
    props.feeState.selectedLeaseTerm,
    props.selectedUnit?.prices ?? [],
    props.selectedUnit?.isFlatPricing ?? false
  );

  const minDate = props.feeState.selectedUnit?.prices
    ? props.feeState.selectedUnit?.prices[0].leaseStartsOn
    : props.feeState.selectedUnit?.availableOn;

  const { mergeAnalyticsData } = useFeesAnalytics();
  const analytics = useAnalytics();

  const updateMoveInData = () => {
    mergeAnalyticsData({
      overrides: {
        event: 'unit_rent_calc_select_move_date',
        action_type: 'select move date',
        click_text: 'Move-in date',
      },
      onComplete: (data) => {
        analytics.trackEvent('unit_rent_calc_select_move_date', data);
      },
    });
  };

  const updateLeaseTermData = () => {
    mergeAnalyticsData({
      overrides: {
        event: 'unit_rent_calc_select_lease_term',
        action_type: 'select lease term',
        click_text: 'Lease length',
      },
      onComplete: (data) => {
        analytics.trackEvent('unit_rent_calc_select_lease_term', data);
      },
    });
  };

  useEffect(() => {
    const flatPricingLeaseTerm = [
      {
        price: props.feeState.selectedBaseRent?.toString(),
        leaseStartsOn: '',
        leaseTerm: '12',
      },
    ];
    if (!props.selectedUnit?.prices) {
      setLeaseTerms(flatPricingLeaseTerm);
    } else {
      const filteredLeaseTerms = (props.selectedUnit?.prices || []).filter(
        (price) => price.leaseStartsOn === props.feeState.selectedMoveInDate
      );
      setLeaseTerms(filteredLeaseTerms);
    }
  }, [
    props.feeState.selectedMoveInDate,
    props.selectedUnit?.prices,
    props.feeState.selectedBaseRent,
  ]);

  return (
    <div className={styles['lease-details']}>
      <h4>Monthly cost calculator</h4>
      <p>
        Get an estimate for your monthly and one time costs. Select lease length, move-in date, and
        optional add-ons.
      </p>
      <div className={styles['lease-details-date-picker']}>
        <DateInput
          id="move-in-date"
          onChange={(date) => {
            props.setSelectedMoveInDate(props.dispatch)(date);
            updateMoveInData();
          }}
          minDate={minDate}
          maxDate={maxDate}
          dateChosen={props.feeState.selectedMoveInDate}
        />
      </div>
      {leaseTerms && props.feeState.selectedMoveInDate && (
        <>
          <div className={styles['lease-details-label']}>
            <p>Lease length</p>
          </div>
          <CustomSelect
            options={leaseTerms}
            value={leaseTerm}
            onChange={(newValue) => {
              props.setSelectedLeaseTerm(props.dispatch)(newValue.toString());
              updateLeaseTermData();
            }}
          />
        </>
      )}
    </div>
  );
};

export default LeaseDetailsSection;
